import { GamesService } from './../Services/games.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-catcontrol',
  templateUrl: './catcontrol.component.html',
  styleUrls: ['./catcontrol.component.css']
})
export class CatcontrolComponent implements OnInit {
  cats=[];
  editEnable:boolean;
  Ecat:string;
  new_cat:boolean;
  new_CatString:string;
  editableCat:string;
  constructor( private games:GamesService,private router:Router) { }

  ngOnInit() {
    this.getAllCats();
  }



    editCat(cat:string){
      this.editEnable=true;
      console.log(cat);
      this.Ecat=cat;

    }
    save(cat){
      let form= new FormData();
      form.append('old_name',cat);
      form.append('new_name',this.editableCat)
      this.games.updateCat(form).subscribe(next=>{console.log(next); this.editEnable=false;this.Ecat="";
       location.reload();
       
    },error=>{console.log(error)});
      
    }

    newCat(){
      let form= new FormData();
      form.append('cat_name',this.new_CatString);
      this.games.NewCat(form).subscribe(next=>{console.log(next);
        location.reload();
      }
      ,error=>{console.log(error)});
    }


  /**
   * get all
   *@description get all cats from backend 
   */

  getAllCats(){
    this.games.getAllCats().subscribe(next=>{
      this.cats=next['cat_lists'];
      console.log(next['cat_lists']);
    },error=>{console.log(error)});
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/catcontrol/catcontrol.component.ts